module.exports = __webpack_public_path__ + "img/gallery-nft-10.f8c74364.png";